(() => {
  const selector = '[data-topfinel-purchase-summary]';
  const optionName = (value) => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  const matchesName = (value, names) => names.includes(optionName(value));
  const colorNames = ['color', 'colour', 'pattern', 'color / pattern', 'pattern / color', '颜色', '图案', '颜色 / 图案'];
  const widthNames = ['width', '宽度'];
  const lengthNames = ['length', '长度'];
  const panelNames = ['panel', 'panels', 'panel count', 'quantity per set', 'pack', 'set', '片数', '面板数'];

  function parseSku(sku) {
    if (!sku || !sku.trim()) return null;
    const match = sku.trim().match(/(\d+)x(\d+)-(\d+)$/);
    if (!match) return null;
    const widthCm = Number(match[1]);
    const lengthCm = Number(match[2]);
    const panels = Number(match[3]);
    if (!Number.isFinite(widthCm) || !Number.isFinite(lengthCm) || ![1, 2].includes(panels)) return null;
    return { widthIn: Math.round(widthCm / 2.54), lengthIn: Math.round(lengthCm / 2.54), panels };
  }

  function optionValue(variant, optionNames, names) {
    const index = optionNames.findIndex((name) => matchesName(name, names));
    return index >= 0 && Array.isArray(variant?.options) ? String(variant.options[index] || '').trim() : '';
  }

  function numericValue(value) {
    const match = String(value || '').match(/\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : null;
  }

  function dimensionValue(value) {
    const numeric = numericValue(value);
    return Number.isFinite(numeric) ? `${numeric}"` : '';
  }

  function panelValue(value) {
    const numeric = numericValue(value);
    return [1, 2].includes(numeric) ? numeric : null;
  }

  function render(summary, variant) {
    const content = summary.querySelector('[data-purchase-summary-content]');
    if (summary.dataset.showSummary !== 'true' || !content) {
      summary.hidden = true;
      if (content) content.textContent = '';
      return;
    }

    let optionNames = [];
    try { optionNames = JSON.parse(summary.dataset.optionNames || '[]'); } catch (error) { optionNames = []; }
    const color = optionValue(variant, optionNames, colorNames);
    const widthOption = optionValue(variant, optionNames, widthNames);
    const lengthOption = optionValue(variant, optionNames, lengthNames);
    const panelOption = optionValue(variant, optionNames, panelNames);
    const sku = parseSku(variant?.sku);
    const width = dimensionValue(widthOption) || (sku ? `${sku.widthIn}"` : '');
    const length = dimensionValue(lengthOption) || (sku ? `${sku.lengthIn}"` : '');
    const panels = panelValue(panelOption) || sku?.panels || null;
    const sizeParts = [width && `${width}W`, length && `${length}L`].filter(Boolean);
    const size = sizeParts.join(' × ');
    const suffix = panels === 2 && size ? `${size} each` : size;
    const text = [color, panels ? `${panels} ${panels === 1 ? 'panel' : 'panels'}` : '', suffix].filter(Boolean).join(' · ');
    if (!text) {
      summary.hidden = true;
      content.textContent = '';
      return;
    }
    content.textContent = text;
    summary.hidden = false;
  }

  function initialize() {
    document.querySelectorAll(selector).forEach((summary) => {
      if (summary.dataset.initialized === 'true') return;
      summary.dataset.initialized = 'true';
      try { render(summary, JSON.parse(summary.dataset.variant || '{}')); } catch (error) { summary.hidden = true; }
    });
  }

  function renderAll(variant) {
    document.querySelectorAll(selector).forEach((summary) => render(summary, variant));
  }

  initialize();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      renderAll(data?.variant);
      window.requestAnimationFrame(initialize);
    });
  }
  new MutationObserver(initialize).observe(document.documentElement, { childList: true, subtree: true });
})();
